export default __webpack_public_path__ + "static/partnerColorIcon20-8aa1c8f6c333da00e563bc5402952e30.svg";